import { render, staticRenderFns } from "./base-switch.vue?vue&type=template&id=f7a094b4"
import script from "./base-switch.ts?vue&type=script&lang=ts&external"
export * from "./base-switch.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7a094b4')) {
      api.createRecord('f7a094b4', component.options)
    } else {
      api.reload('f7a094b4', component.options)
    }
    module.hot.accept("./base-switch.vue?vue&type=template&id=f7a094b4", function () {
      api.rerender('f7a094b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vuetify/Switch/base-switch.vue"
export default component.exports